import { useContext } from 'react';
import { GlobalStoreContext } from '../state/GlobalStore';
import { User } from '../types/UserTypes';

interface AuthResult {
  success: boolean;
  user?: User;
  error?: any;
}

interface GlobalStoreContext {
  state: {
    advances: number;
    registrations: number;
    user: User | null;
    risky_advances?: number;
    supportTickets?: number;
  };
  fetchStats: () => void;
  loginUser: () => Promise<AuthResult>;
  logOutUser: () => Promise<void>;
}

export const useGlobalStore = (): GlobalStoreContext => {
  const context = useContext(GlobalStoreContext);

  if (!context) {
    throw new Error('useGlobalStore must be used within a GlobalStore provider');
  }

  return context as GlobalStoreContext;
};